import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p491544589850841088',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
